import QuickAdd from "./QuickAdd";

export default QuickAdd;
